import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import { Grid } from '@material-ui/core';
import TextInputFieldWithValidation from '../../../../components/ValidationFormElements/TextInputFieldWithValidation';
import TextMaskCustom from '../../../../components/MUI/TextMaskCustom';
import useStyles from './makeStyles';

const PropertyRow = ({ subTitleNum, data, onDataChange, isDeletable, handleDelete, errors, clearError }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const handlePropertyPriceChange = (value) => {
    const fixedValue = value.replace(/[^0-9]/g, '');
    onDataChange({ ...data, propertyPrice: Number(fixedValue) }, 'propertyPrice');
  };

  const handlePropertyNameChange = (value) => {
    onDataChange({ ...data, propertyName: value }, 'propertyName');
  };

  const handlePropertyYearChange = (value) => {
    onDataChange({ ...data, propertyYear: value }, 'propertyYear');
  };

  const handleDamageDescriptionChange = (value) => {
    onDataChange({ ...data, damageDescription: value }, 'damageDescription');
  };

  const {
    id,
    propertyName = '',
    propertyYear = '',
    propertyPrice = 0,
    damageDescription = '',
  } = data;

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div className={classes.subTitleRow}>
          <div className={classes.subTitle}>
            {`${t('propertyClaim.accInfo.propertyRows.subTitle')} ${subTitleNum}`}
          </div>
        </div>
        {isDeletable && (
        <div
          className={classes.minusIcon}
          onClick={() => handleDelete(id)}
          role="presentation"
        >
          <Icon name="minus circle" className={classes.removeIcon} />
        </div>
        )}
      </div>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <TextInputFieldWithValidation
            formProps={{ errors, clearError }}
            labelKey="propertyClaim.accInfo.propertyRows.propertyName"
            name={`propertyName_${id}`}
            handleChange={(e) => handlePropertyNameChange(e.target.value)}
            value={propertyName}
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInputFieldWithValidation
            placeholder="yyyy"
            formProps={{ errors, clearError }}
            labelKey="propertyClaim.accInfo.propertyRows.propertyYear"
            name={`propertyYear_${id}`}
            value={propertyYear}
            handleChange={(e) => {
              handlePropertyYearChange(e.target.value);
            }}
            InputProps={{
              inputComponent: TextMaskCustom,
              inputProps: {
                handler: 'propertyYearMask',
              },
            }}
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInputFieldWithValidation
            formProps={{ errors, clearError }}
            labelKey="propertyClaim.accInfo.propertyRows.propertyPrice"
            name={`propertyPrice_${id}`}
            handleChange={(e) => handlePropertyPriceChange(e.target.value)}
            value={propertyPrice ? propertyPrice.toLocaleString('en-US') : ''}
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInputFieldWithValidation
            formProps={{ errors, clearError }}
            labelKey="propertyClaim.accInfo.propertyRows.damageDescription"
            name={`damageDescription_${id}`}
            handleChange={(e) => handleDamageDescriptionChange(e.target.value)}
            value={damageDescription}
            required
          />
        </Grid>
      </Grid>
    </div>
  );
};

PropertyRow.propTypes = {
  errors: PropTypes.shape({}),
  clearError: PropTypes.func,
  data: PropTypes.shape({
    id: PropTypes.number.isRequired,
    propertyName: PropTypes.string,
    propertyYear: PropTypes.string,
    propertyPrice: PropTypes.number,
    damageDescription: PropTypes.string,
  }).isRequired,
  subTitleNum: PropTypes.number.isRequired,
  onDataChange: PropTypes.func.isRequired,
  isDeletable: PropTypes.bool.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

PropertyRow.defaultProps = {
  errors: {},
  clearError: () => { },
};

export default PropertyRow;
